import { getObjectWithLowerCaseKeys } from '../utils/objectUtils';
/**
 * Represents a notification item.
 */
export class Notification {
    timestamp;
    localDate;
    type;
    area;
    message;
    title;
    url;
    readAt;
    jobId;
    jobType;
    triggerDownload;
    constructor(timestamp, localDate, type, area, message, title, url, readAt, jobId, jobType, triggerDownload = false) {
        this.timestamp = timestamp;
        this.localDate = localDate;
        this.type = type;
        this.area = area;
        this.message = message;
        this.title = title;
        this.url = url;
        this.readAt = readAt;
        this.jobId = jobId;
        this.jobType = jobType;
        this.triggerDownload = triggerDownload;
    }
    /**
     * Creates a Notification instance from a raw backend object.
     * Keys are normalized to lowercase.
     *
     * @param obj - Raw notification payload (NotificationDto)
     */
    static from(obj) {
        return Object.assign(new Notification(new Date()), getObjectWithLowerCaseKeys(obj));
    }
}
